module.exports = __webpack_public_path__ + "img/borderHeartWhite.fe683189.svg";